import { useIntlModule } from 'utils/intl/useIntlModule';
import messages from './settings.intl.json';

export const useSettingsIntl = () => useIntlModule(messages);
